import { render, staticRenderFns } from "./PatientSelector.vue?vue&type=template&id=551fb30c&"
import script from "./PatientSelector.vue?vue&type=script&lang=ts&"
export * from "./PatientSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports